import CleanLayout from '@/layouts/CleanLayout';
import TrainerApplyMultiStep from '@/domain/TrainerApplyMultiStepForm';

export default function TrainerCoachApply() {
  return <TrainerApplyMultiStep />;
}

TrainerCoachApply.layoutProps = {
  Layout: CleanLayout,
};
